﻿import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";

// Import Model
import { AddressInformationData } from "../../../model/jubili/address-information/address-information";
import { apiLink } from "../../../constant/api-link";

@Injectable({
  providedIn: "root"
})
export class AddressInformationService {

    constructor(
        private http: HttpClient
    ) { }

    addressInformationData: AddressInformationData = new AddressInformationData();

    // API get
    // get all country
    getCountry(languageCode: string): Observable<Array<AddressInformationData>> {
        const url = apiLink.getAddressCountry;

        const params = new HttpParams().set("languageCode", languageCode);

        return this.http.get<Array<AddressInformationData>>(url, { params });

    }

    // get all province by country
    getProvince(countryCode: string, languageCode: string): Observable<Array<AddressInformationData>> {
        const url = apiLink.getAddressProvince;

        const params = new HttpParams()
            .set("countryCode", countryCode)
            .set("languageCode", languageCode);

        return this.http.get<Array<AddressInformationData>>(url, { params });

    }

    // get all district by province
    getDistrict(provinceCode: string, languageCode: string): Observable<Array<AddressInformationData>> {

        const url = apiLink.getAddressDistrict;

        const params = new HttpParams()
            .set("provinceCode", provinceCode)
            .set("languageCode", languageCode);

        return this.http.get<Array<AddressInformationData>>(url, { params });
    }
}
